import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { Spinkit } from 'ng-http-loader';
import { HttpService } from 'src/app/services/http/http.service';
import swal from 'sweetalert2'
import { TCModalService } from 'src/app/ui/services/modal/modal.service';
import { Content } from 'src/app/ui/interfaces/modal';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-aggregrator',
  templateUrl: './aggregrator.component.html',
  styleUrls: ['./aggregrator.component.scss']
})
export class AggregratorComponent implements OnInit {
  cuisineArray:any[] = []
  cuisineImages:any[] = []
  categoryArray:any[] = []
  allrestaurant = []
  UserCondition
  longitude
  latitude
  decode
  decodetableID
  searchText
  public spinkit = Spinkit;
  userCurrentLocation
  restoOne = []
  token
  ids
  tableids
  userCurrentLocations
  restoTwo = []
  restoConditions
  constructor(
    public httpSv: HttpService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private _bottomSheet: MatBottomSheet,
    private changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
  ) { }
  ngOnInit(): void {
    this.restoConditions = '1';
    this.ids = sessionStorage.getItem('restoIds')
    this.tableids = sessionStorage.getItem('tableIds')
    this.token = sessionStorage.getItem('access_token')
    this.userCurrentLocations = sessionStorage.getItem('visitorOrigin');
    this.route.queryParams.subscribe(params => {
      this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    });
    this.getCategory();
    this.getAllCuisines();
    sessionStorage.removeItem("orders-data");
    sessionStorage.removeItem("FianlArray");
    sessionStorage.removeItem("count");
    sessionStorage.removeItem("addon-orders");

    this.lat = sessionStorage.getItem('lat');
    this.lng = sessionStorage.getItem('lng')
    // if (this.lat && this.lng) {
    //   this.latitude = this.lat;
    //   this.longitude = this.lng
    //   this.getOfflineRestaurant();
    // } else {
    //   this.getOfflineRestaurant()
    //   this.userCurrentLocation = false;
    //   let sheetRef = this._bottomSheet.open(BottomSheetGuestUserLocation,{
    //     disableClose:true
    //   });
     
    //   this.userCurrentLocation = false;
    //   sheetRef.afterDismissed().subscribe((dataFromChild) => {
    //     if (dataFromChild.code === 1) {
    //       this.userCurrentLocations = dataFromChild.message;
    //       const dialogRef = this.dialog.open(LocationPermission, {
    //         width: "321px",
    //         height: "163px"
    //       });
    //     } else {
    //       this.userCurrentLocations = dataFromChild;
    //       this.userCurrentLocation = true;
    //     }
    //   });
    // }
        this.userCurrentLocations = sessionStorage.getItem('visitorOrigin');
    if (this.userCurrentLocations ) {
      this.userCurrentLocation = true;
    } else {
      this.userCurrentLocation = false;
    }
  }
  // ngAfterViewInit(): void {
  //   //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
  //   //Add 'implements AfterViewInit' to the class.
  //  setTimeout(()=>{
  //   let h = document.getElementById('back-mobile-img')
  //   console.log(h,h.clientWidth)
  //   document.getElementById('div-cointainer').style.width = `${h.clientWidth}px`
  //  },100)
  // }
  filterToggele = false
  showCatFilter() {
    this.filterToggele = !this.filterToggele
    if (this.filterToggele)
      document.getElementById('cat-filter-arrowImg').style.transform = 'rotate(180deg)'
    else
      document.getElementById('cat-filter-arrowImg').style.transform = 'rotate(0deg)'
  }
  goToSearchPage() {
    this.restoConditions = "2";
  }
  showFilteredResto: boolean = false
  checkFiletered(e) {
    if (e.length >= 3) {
      this.showFilteredResto = true;
    } else {
      this.showFilteredResto = false;
    }
  }
  gotoRestos() {
    this.restoConditions = "1";
    this.searchText = '';
    this.showFilteredResto = false;
  }
  panelOpenState = false
  mainCategoryArray = []
  categoryType = []
  categoryWithoutType = []
  showMoreFalg = false;
  showMoreCondition = false;
  getCategory() {
    this.httpSv.getAllCategories().subscribe((res: any) => {
      let temp = res.result.data
      temp.forEach(element => {
        this.categoryType.push(element.type)
        element.category.forEach(ele => {
          this.categoryWithoutType.push(ele)
        })
      });
      let sorted = this.categoryWithoutType.sort((a, b) => {
        if (a.display_order === b.display_order) {
          return 0;
        }

        // nulls sort after anything else
        if (a.display_order === null) {
          return 1;
        }
        if (b.display_order === null) {
          return -1;
        }

        // otherwise, if we're ascending, lowest sorts first
        return parseInt(a.display_order) < parseInt(b.display_order) ? -1 : 1;
      })
      this.categoryWithoutType = sorted.map(ele => ele)
      this.mainCategoryArray = res.result.data;
      if (this.categoryWithoutType.length > 11) {
        for (let i = 0; i < 12; i++) {
          this.categoryArray.push(this.categoryWithoutType[i])
        }
        this.showMoreFalg = true;
        this.showMoreCondition = true;
      } else {
        this.categoryArray = this.categoryWithoutType
        this.showMoreCondition = false;
        this.showMoreFalg = false;
      }
    }, (err: any) => {
      console.log(err)
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }
  showMoreFunc() {
    this.categoryArray = this.categoryWithoutType
    this.showMoreFalg = false;
  }
  showLessFunc() {
    this.categoryArray = []
    for (let i = 0; i < 12; i++) {
      this.categoryArray.push(this.categoryWithoutType[i])
    }
    this.showMoreFalg = true;
  }
  selectedFilter = []
  filterSelectFunc(name, event) {
    if (event.checked) {
      this.selectedFilter.push(name)
    }
    else {
      let reqIndex = this.selectedFilter.findIndex(ele => ele == name)
      this.selectedFilter.splice(reqIndex, 1)
    }
    this.showFilterCatFunc()
  }
  filterCrossFunc(name) {
    let reqIndex = this.selectedFilter.findIndex(ele => ele == name)
    this.selectedFilter.splice(reqIndex, 1)
    this.showFilterCatFunc()
  }
  outsideClick(hasClickedOutside){
    if(hasClickedOutside){
      if(this.filterToggele){
      this.filterToggele = false
      document.getElementById('cat-filter-arrowImg').style.transform = 'rotate(0deg)'
      }
    }
  }
  showFilterCatFunc() {
    this.categoryArray = []
    if (this.selectedFilter.length > 0) {
      this.selectedFilter.forEach(ele => {
        this.mainCategoryArray.forEach(element => {
          if (element.type == ele) {
            element.category.forEach(item => {
              this.categoryArray.push(item)
            })
          }
        })
      })
    }
    else {
      if (this.categoryWithoutType.length > 11) {
        for (let i = 0; i < 12; i++) {
          this.categoryArray.push(this.categoryWithoutType[i])
        }
        this.showMoreFalg = true;
        this.showMoreCondition = true;
      } else {
        this.categoryArray = this.categoryWithoutType
        this.showMoreCondition = false;
        this.showMoreFalg = false;
      }
    }
  }
  catFilterPreCheck(name) {
    if (this.selectedFilter.includes(name)) return true
    else false
  }

  showAllResto: boolean = false;
  showAllRestos() {
    this.showAllResto = true;
  }

  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], {
            queryParams: {
              id: this.ids,
              table_id: this.tableids
            }
          });
        }
      }
    )
  }
  mainCuisineArray
  showMoreCatFalg
  showMoreCatCondition

  getAllCuisines() {
    this.httpSv.getAllCuisines().subscribe((res: any) => {
      this.mainCuisineArray = res['result'].data;
      if (this.mainCuisineArray.length > 12) {
        for (let i = 0; i < 12; i++) {
          this.cuisineArray.push(this.mainCuisineArray[i])
        }
        this.showMoreCatFalg = true;
        this.showMoreCatCondition = true;
      } else {
        this.cuisineArray = this.mainCategoryArray
        this.showMoreCatCondition = false;
        this.showMoreCatFalg = false;
      }
      this.cuisineImages = this.cuisineArray.map(item => ({
        path: item.image,
        index: 5
      }))
    }, (err: any) => {
      console.log(err);
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }
  images = [
    { path: 'https://source.unsplash.com/800x600/?nature' },
    { path: 'https://source.unsplash.com/800x600/?car' },
    { path: 'https://source.unsplash.com/800x600/?moto' },
    { path: 'https://source.unsplash.com/800x600/?fantasy' },
  ]


  gotoResto() {
    this.showAllResto = false;
    this.getOfflineRestaurant();
    this.categoryCheckList = []
    this.cuisineCheckList = []
    this.conditionCatFilter = false
    this.conditionCusineFilter = false
  }

  getCategoryFilter(catId) {
    if (this.latitude && this.longitude) {
      this.httpSv.getAllFilteredCategories(this.latitude, this.longitude, catId).subscribe((res: any) => {
        this.allrestaurant = res['result'].data;
        this.showAllResto = true;
      }, (err: any) => {
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
        console.log(err);
        this.showAllResto = false;
        this._snackBar.open("No Restaurants Found!");
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      })
    } else {
      this.httpSv.getFilteredCategories(catId).subscribe((res: any) => {
        this.allrestaurant = res['result'].data;
        this.showAllResto = true;
      }, (err: any) => {
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
        console.log(err);
        this.showAllResto = false;
        this._snackBar.open("No Restaurants Found!");
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      })
    }
  }

  getCuisineFilter(cuisineId) {
    if (this.latitude && this.longitude) {
      this.httpSv.getAllFilteredCuisine(this.latitude, this.longitude, cuisineId).subscribe((res: any) => {
        this.allrestaurant = res['result'].data;
        this.showAllResto = true;
      }, (err: any) => {
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
        console.log(err)
        this.showAllResto = false;
        this._snackBar.open("No Restaurants Found!");
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      })
    } else {
      this.httpSv.getFilteredCusine(cuisineId).subscribe((res: any) => {
        this.allrestaurant = res['result'].data;
        this.showAllResto = true;
      }, (err: any) => {
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
        console.log(err)
        this.showAllResto = false;
        this._snackBar.open("No Restaurants Found!");
        setTimeout(() => {
          this._snackBar.dismiss();
        }, 2000);
      })
    }
  }

  onLink(id, tableid, visitorOrigin) {
    if (this.UserCondition) {
      this.router.navigate(['/horizontal/food-menu'])
    } else {
      this.router.navigate(['/public/food-menu-guest'])
    }
    sessionStorage.setItem("restoIds", id)
    sessionStorage.setItem("tableIds", tableid)
    sessionStorage.setItem("visitorOrigin", visitorOrigin)
    if(parseInt(id )){
      this.decode = id
    }else
    this.decode = atob(id)
    this.decodetableID = atob(tableid)
    sessionStorage.setItem('restoId', this.decode)
    sessionStorage.setItem('restoIDCopy', this.decode);
    sessionStorage.setItem('tableId', this.decodetableID)
  }

  getOfflineRestaurant() {
    if (this.latitude && this.longitude) {
      this.httpSv.getAllOfflineRestaurants(this.latitude, this.longitude).subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          this.userCurrentLocation = true;
          this.userCurrentLocations = res.result.data[0].visitorOrigin;
          this.allrestaurant = res['result'].data;
          this.restoOne = this.allrestaurant.slice(0, 1);
          this.restoTwo = this.allrestaurant.slice(1, 2);
        }
      }, (err: any) => {
        console.log(err)
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      })
    } else {
      this.httpSv.getRestoWithoutLocation().subscribe((res: any) => {
        if (res['status'] == "TRUE") {
          this.userCurrentLocation = true;
          this.allrestaurant = res['result'].data;
          this.restoOne = this.allrestaurant.slice(0, 1);
          this.restoTwo = this.allrestaurant.slice(1, 2);
          this.userCurrentLocations = res.result.data[0].visitorOrigin;
        }
      }, (err: any) => {
        console.log(err)
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      })
    }
  }

  markerDragEnd($event: MouseEvent) {
    console.log($event);
    // this.latitude = $event.coords.lat;
    // this.longitude = $event.coords.lng;
    // this.getAddress(this.latitude, this.longitude);
  }
  openLocationMap() {
    this.lat = sessionStorage.getItem('lat');
    this.lat = parseFloat(this.lat);
    this.lng = sessionStorage.getItem('lng')
    this.lng = parseFloat(this.lng)
    this.restoConditions = "3";
    let data = {
      userCurrentLocation: this.userCurrentLocations,
    }

    let sheetRef = this._bottomSheet.open(BottomSheetGuestConfirmLocation, {
      data: data,
      disableClose: true
    });

    sheetRef.afterDismissed().subscribe((dataFromChild) => {
      this.userCurrentLocations = dataFromChild;
      sessionStorage.setItem("userLocation", this.userCurrentLocations)
      this.restoConditions = "1";
      this.userCurrentLocation = true;
    });
    // let sheetRef = this._bottomSheet.open(BottomSheetConfirmLocation);
    // this.router.navigate(['/public/user-location'])
  }
  lat
  lng
  getLocation() {
    console.log("get location")
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;

          sessionStorage.setItem('lat', this.lat);
          sessionStorage.setItem('lng', this.lng);
          this.httpSv.getAllOfflineRestaurants(this.lat, this.lng).subscribe((res: any) => {
            if (res['status'] == "TRUE") {
              this.userCurrentLocation = true;
              this.allrestaurant = res['result'].data;
              this.restoOne = this.allrestaurant.slice(0, 1);
              this.restoTwo = this.allrestaurant.slice(1, 2);
              this.userCurrentLocations = res.result.data[0].visitorOrigin;
            }
          }, (err: any) => {
            console.log(err)
          })
        }
      },
        (error: PositionError) => {
          this.getOfflineRestaurant();
        });
    } else {
      swal.fire("Geolocation is not supported by this browser.");
    }
  }
  private destroyed = false;
  ngOnDestroy() {
		this.destroyed = true;
		this.changeDetectorRef.detach(); 
	}

	triggerChangeDetection() {
	  if (!this.destroyed) {
		this.changeDetectorRef.detectChanges();
	  }
	}
  conditionCatFilter = false
  conditionCusineFilter = false
  categoryCheckList:any[] = []
  cuisineCheckList:any[] = []
  catCheckbokFunc(e: any, imgId) {
    if (e.target.checked) {
      this.categoryCheckList.push(parseInt(e.target.value))
      document.getElementById(imgId).style.display = 'inline-block'
    } else {
      let index = this.categoryCheckList.findIndex((ele) => ele == e.target.value)
      this.categoryCheckList.splice(index, 1)
      document.getElementById(imgId).style.display = 'none'
    }
    if (this.categoryCheckList.length != 0) {
      this.conditionCatFilter = true
    } else {
      this.conditionCatFilter = false
    }
  }

  cuisineCheckbokFunc(e: any , imgId) {
    if (e.target.checked) {
      document.getElementById(imgId).style.display = 'inline-block'
      this.cuisineCheckList.push(parseInt(e.target.value))
    } else {
      let index = this.cuisineCheckList.findIndex((ele) => ele == e.target.value)
      this.cuisineCheckList.splice(index, 1)
      document.getElementById(imgId).style.display = 'none'
    }
    if (this.cuisineCheckList.length != 0) {
      this.conditionCusineFilter = true
    } else {
      this.conditionCusineFilter = false
    }
  }
  getFilterResto() {
    let data = {
      lat: this.latitude,
      long: this.longitude,
      category_id: this.categoryCheckList,
      cuisine_id: this.cuisineCheckList,
      restaurant_name: ""
    }
    this.httpSv.getAllRestoByMutiCat(data).subscribe(res => {
      this.allrestaurant = res['result'].data;
      this.showAllResto = true;
      this.categoryCheckList.splice(0, this.categoryCheckList.length)
      this.cuisineCheckList.splice(0, this.cuisineCheckList.length)
      this.conditionCatFilter = false
      this.conditionCusineFilter = false
    }, (err: any) => {
      console.log(err);
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
      this.showAllResto = false;
      this._snackBar.open("No Restaurants Found!");
      setTimeout(() => {
        this._snackBar.dismiss();
      }, 2000);
    })
    // this.httpSv.getAllFilteredCategories(this.latitude, this.longitude, catId).subscribe((res: any) => {
    //   this.allrestaurant = res['result'].data;
    //   this.showAllResto = true;
    // }, (err: any) => {
    //   console.log(err);
    //   if (err.status == 401 || err.status == 500) {
    //     this.logout();
    //   }
    //   this.showAllResto = false;
    //   this._snackBar.open("No Restaurants Found!");
    //   setTimeout(() => {
    //     this._snackBar.dismiss();
    // }, 2000);

  }
  showMoreCatFunc() {
    this.cuisineArray = this.mainCuisineArray
    this.showMoreCatFalg = false;
  }
  showLessCatFunc() {
    this.cuisineArray = []
    for (let i = 0; i < 12; i++) {
      this.cuisineArray.push(this.mainCuisineArray[i])
    }
    this.showMoreCatFalg = true;
  }
  openAppStore(){
    window.open('https://apps.apple.com/in/app/foodbud/id1584641741')
  }
  openPlayStore(){
    window.open('https://play.google.com/store/apps/details?id=com.cms.foodbud')
  }
  goBackToMenu(){
    this.router.navigate(['/public/food-menu'])
  }

}

@Component({
  selector: 'bottom-sheet-guest-user-location',
  templateUrl: 'bottom-sheet-guest-user-location.html',

})

export class BottomSheetGuestUserLocation implements OnInit {
  UserCondition

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private router: Router,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetGuestUserLocation>,
    private _bottomSheet: MatBottomSheet,
    private changeDetectorRef: ChangeDetectorRef,
    public httpSv: HttpService,) {
    this.data = data
  }
  ngOnInit() {
    this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
  }

  close_popup() {
    this.bottomSheetRef.dismiss('User denied Geolocation');
  }

  grantLocation() {
    this.getLocation();
  }
  lng
  lat
  userCurrentLocations
  userCurrentLocation
  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        if (position) {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;

          sessionStorage.setItem('lat', this.lat);
          sessionStorage.setItem('lng', this.lng);
          this.httpSv.getAllOfflineRestaurants(this.lat, this.lng).subscribe((res: any) => {
            if (res['status'] == "TRUE") {
              this.userCurrentLocation = true;
              this.userCurrentLocations = res.result.data[0].visitorOrigin;
              sessionStorage.setItem('visitorOrigin', this.userCurrentLocations);
              sessionStorage.setItem("userLocation", this.userCurrentLocations)
              this.bottomSheetRef.dismiss(this.userCurrentLocations);
            }
          }, (err: any) => {
            this.bottomSheetRef.dismiss();
            console.log(err)
          })
        }
      },
        (error: PositionError) => {
          console.log(error)
          this.bottomSheetRef.dismiss(error);
        });
    } else {
      swal.fire("Geolocation is not supported by this browser.");
    }
  }

  showLocationPage() {
    this.bottomSheetRef.dismiss();
    this.router.navigate(['/public/user-location']);
  }

  private destroyed = false;
  ngOnDestroy() {
		this.destroyed = true;
		this.changeDetectorRef.detach(); 
	}

	triggerChangeDetection() {
	  if (!this.destroyed) {
		this.changeDetectorRef.detectChanges();
	  }
	}

}

@Component({
  selector: 'bottom-sheet-guest-confirm-location',
  templateUrl: 'bottom-sheet-guest-confirm-location.html',

})

export class BottomSheetGuestConfirmLocation implements OnInit {
  UserCondition
  location
  showDiv: boolean = false;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private router: Router,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetGuestConfirmLocation>,
    private _bottomSheet: MatBottomSheet,
    public httpSv: HttpService,
    private changeDetectorRef: ChangeDetectorRef) {
    this.data = data
  }
  disableConfirmButton : boolean = false;
  ngOnInit() {
    this.showDiv = true;
    this.location = this.data.userCurrentLocation;
    if(this.location ==='User denied Geolocation') {
      this.disableConfirmButton = true;
    }
    this.changeDetectorRef.detectChanges();
  }

  close_popup() {
    this.bottomSheetRef.dismiss();
  }

  changeLocation() {
    this.bottomSheetRef.dismiss();
    this.router.navigate(['/public/user-location']);
  }

  userCurrentLocation
  userCurrentLocations
  restoConditions
  confirmLocation() {
    this.userCurrentLocations = this.location;
    this.restoConditions = '1';
    this.userCurrentLocation = true;
    this.bottomSheetRef.dismiss(this.userCurrentLocations);
    sessionStorage.setItem("userLocation", this.userCurrentLocations)
  }

  private destroyed = false;
  ngOnDestroy() {
		this.destroyed = true;
		this.changeDetectorRef.detach(); 
	}

	triggerChangeDetection() {
	  if (!this.destroyed) {
		this.changeDetectorRef.detectChanges();
	  }
	}
}

@Component({
  selector: 'location-permission',
  templateUrl: 'location-permission.html',
})
export class LocationPermission implements OnInit {
  
  constructor(
    public dialogRef: MatDialogRef<LocationPermission>,
    @Inject(MAT_DIALOG_DATA) public data,
    private _bottomSheet: MatBottomSheet,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef
  ) { }
  ngOnInit(): void {

  }

  imsure(): void {
    this.dialogRef.close();
    this.router.navigate(['/public/resto'])
  }

  retry() {
    this.dialogRef.close();
    let sheetRef = this._bottomSheet.open(BottomSheetGuestUserLocation);
  }

  private destroyed = false;
  ngOnDestroy() {
		this.destroyed = true;
		this.changeDetectorRef.detach(); 
	}

	triggerChangeDetection() {
	  if (!this.destroyed) {
		this.changeDetectorRef.detectChanges();
	  }
	}
}